import { authedJSON, authedVoid } from './http'

export type SnapshotRange = '1D' | '1W' | '1M' | '3M' | '1Y' | 'ALL'

export interface SnapshotPoint {
  t: number
  v: number
}

export interface SnapshotSeries {
  range: SnapshotRange
  points: SnapshotPoint[]
}

export interface SnapshotRecordPayload {
  accountId: string
  portfolioValue: number
  positionsValue: number
  cashValue: number
  dayChange: number
}

export function getPortfolioSnapshots(
  accountId: string,
  range: SnapshotRange,
): Promise<SnapshotSeries> {
  return authedJSON<SnapshotSeries>(
    `/api/portfolio/snapshots?accountId=${encodeURIComponent(accountId)}&range=${range}`,
  )
}

export function recordPortfolioSnapshot(payload: SnapshotRecordPayload): Promise<void> {
  return authedVoid('/api/portfolio/snapshots', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}
